import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { userCreate } from 'Modules/UsersModule/actionsAsync'
import { userCreateModalHide } from 'Global/Stores/modals'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    close: () => dispatch(userCreateModalHide()),
    create: (email, firstName, lastName) => dispatch(userCreate(email, firstName, lastName)),
  })

  Enhancer.displayName = 'CreateUserModalEnhancer'

  Enhancer.propTypes = {
    close: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
